import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Gap', null, { withChildren: true });
